import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { StationDialogComponent } from '../dialogs/station-dialog/station-dialog.component';
import { DurationDialogComponent } from '../dialogs/duration-dialog/duration-dialog.component';
import { TaskModel } from '../models/station.model';
import { PopUpDialogComponent } from '../pop-up-dialog/pop-up-dialog.component';
import { DialogType } from 'src/app/shared/models/dialog-type.enum';
import { ManualSubmissionDialogComponent } from 'src/app/modules/energy-credits/dialogs/manual-submission/manual-submission-dialog.component';
import { SaveChangesDialogComponent } from '../dialogs/save-changes-dialog/save-changes-dialog.component';

@Injectable({
  providedIn: 'root',
})

/**
 * Service used to create global dialog component
 * pass in the title, message, button text
 * can be built upon
 */
export class DialogService {
  constructor(private dialog: MatDialog) { }

  getDialogComponent(dialogId: number) {
    switch (dialogId) {
      case DialogType.MANUAL_SUBMISSION:
        return ManualSubmissionDialogComponent
        break;
      default:
        return PopUpDialogComponent
        break;
    }
  }

  openDialog(
    title: string,
    message: string,
    cancelButtonText: string,
    confirmButtonText: string,
    showCancelButton: boolean = false
  ) {
    const dialogRef = this.dialog.open(PopUpDialogComponent, {
      data: {
        title: title,
        message: message,
        cancelButtonText: cancelButtonText,
        confirmButtonText: confirmButtonText,
        confirmClicked: true,
        showCancelButton: showCancelButton,
      },
    });

    return dialogRef;
  }

  openCustomDialog(
    dialogId: number, data?: any
  ) {
    const dialogRef = this.dialog.open(
      this.getDialogComponent(dialogId) as any, {
      data: {
        ...(data && data)
      },
    });

    return dialogRef;
  }

  openStationDialog(
    title: string,
    inputTitle: string,
    inputPlaceholder: string,
    inputValue: string,
    cancelButtonText: string,
    confirmButtonText: string
  ) {
    const dialogRef = this.dialog.open(StationDialogComponent, {
      data: {
        title: title,
        inputTitle: inputTitle,
        inputPlaceholder: inputPlaceholder,
        inputValue: inputValue,
        cancelButtonText: cancelButtonText,
        confirmButtonText: confirmButtonText,
        confirmClicked: true,
      },
    });

    return dialogRef;
  }

  openDurationDialog(
    title: string,
    dialogMessage: string,
    datePickerLabel: string,
    cancelButtonText: string,
    confirmButtonText: string,
    task: TaskModel,
    stationList: any
  ) {
    const dialogRef = this.dialog.open(DurationDialogComponent, {
      data: {
        title: title,
        dialogMessage: dialogMessage,
        datePickerLabel: datePickerLabel,
        cancelButtonText: cancelButtonText,
        confirmButtonText: confirmButtonText,
        task: task,
        stationList: stationList,
      },
    });

    return dialogRef;
  }

  //open save changes dialog
  openSaveChangesDialog(
    title: string,
    message: string,
    cancelButtonText: string,
    confirmButtonText: string
  ) {
    const dialogRef = this.dialog.open(SaveChangesDialogComponent, {
      data: {
        title: title,
        message: message,
        cancelButtonText: cancelButtonText,
        confirmButtonText: confirmButtonText,
        confirmClicked: true
      },
    });

    return dialogRef;
  }
}
